import { type ParentProps, splitProps } from "solid-js";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  type dialogContentProps,
} from "@/components/ui/dialog";
import { cn } from "@/libs/cn";

type RefineEditDialogProps = ParentProps<
  dialogContentProps & {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    title: string;
  }
>;

export function RefineEditDialog(props: RefineEditDialogProps) {
  const [local, rest] = splitProps(props, [
    "class",
    "children",
    "open",
    "onOpenChange",
    "title",
  ]);
  return (
    <Dialog open={local.open} onOpenChange={local.onOpenChange}>
      <DialogContent class={cn("max-w-2xl", local.class)} {...rest}>
        <DialogHeader>
          <DialogTitle>{local.title}</DialogTitle>
        </DialogHeader>
        {local.children}
      </DialogContent>
    </Dialog>
  );
}
